module.exports = __webpack_public_path__ + "img/Bundesliga_1_400x416@2x.2630a6a9.jpg";